import React from 'react';
import { useStore } from 'effector-react';
import { $loadedScene } from '@stores/loadedStore';
import { RotateTimeline } from './RotateTimeline';
import { RotateHeader } from './RotateHeader';
import { RotateCurrentTime } from './RotateCurrentTime';
import { RotateClear } from './RotateClear';

export function RotateEditor() {
  const scene = useStore($loadedScene);
  if (!scene) return null;

  return (
    <div className="mt-10 flex flex-col bg-black-#28">
      <RotateHeader />
      <div className="flex flex-1 select-none bg-black-#28">
        <div className="mr-5 w-100 border-r border-black-#34">
          <RotateCurrentTime />
          <div className="h-185">
            <div className="relative mt-20 flex h-50 flex-col items-center justify-center">
              <div>导览节点</div>
              <RotateClear />
            </div>
            <div className="relative mt-10 flex h-40 items-center justify-center">
              AI讲解
            </div>
            <div className="relative mt-10 flex h-25 items-center justify-center">
              讲解字幕
            </div>
          </div>
        </div>
        <RotateTimeline />
      </div>
    </div>
  );
}
